import { STATE_COLORS } from './statusColors';

// Mirrors src/Domain/Enums/AssessmentStatus.cs — values are stored/serialized as ints.
// Values are appended (never reordered), hence the non-sequential look.
// IN_MITIGATION / PENDING_FINAL_REVIEW are FMECA-only (its two-level approval); NPA
// never uses them.
export const ASSESSMENT_STATUS = Object.freeze({
  IN_PROGRESS: 0,
  COMPLETED: 1,
  UNDER_REVIEW: 2,
  IN_MITIGATION: 3,
  PENDING_FINAL_REVIEW: 4,
});

export const ASSESSMENT_STATUS_LABELS = Object.freeze({
  [ASSESSMENT_STATUS.IN_PROGRESS]: 'In Progress',
  [ASSESSMENT_STATUS.UNDER_REVIEW]: 'Under Review',
  [ASSESSMENT_STATUS.IN_MITIGATION]: 'In Mitigation',
  [ASSESSMENT_STATUS.PENDING_FINAL_REVIEW]: 'Pending Final Review',
  [ASSESSMENT_STATUS.COMPLETED]: 'Completed',
});

export const ASSESSMENT_STATUS_COLORS = Object.freeze({
  [ASSESSMENT_STATUS.IN_PROGRESS]: STATE_COLORS.INPROGRESS,
  [ASSESSMENT_STATUS.UNDER_REVIEW]: STATE_COLORS.OPEN,
  [ASSESSMENT_STATUS.IN_MITIGATION]: STATE_COLORS.INPROGRESS,
  [ASSESSMENT_STATUS.PENDING_FINAL_REVIEW]: STATE_COLORS.OPEN,
  [ASSESSMENT_STATUS.COMPLETED]: STATE_COLORS.COMPLETE,
});

// Mirrors src/Domain/Enums/ReviewDecision.cs (serialized as strings in review DTOs).
export const REVIEW_DECISION = Object.freeze({
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
});

// Mirrors src/Domain/Enums/ReviewLevel.cs (serialized as strings in review DTOs).
export const REVIEW_LEVEL = Object.freeze({
  ASSESSMENT_REVIEW: 'AssessmentReview',
  FINAL_REVIEW: 'FinalReview',
});

export const REVIEW_LEVEL_LABELS = Object.freeze({
  [REVIEW_LEVEL.ASSESSMENT_REVIEW]: 'Assessment',
  [REVIEW_LEVEL.FINAL_REVIEW]: 'Final',
});

// Mirrors the assessment-type discriminator used across assessment DTOs (e.g. the Inbox).
export const ASSESSMENT_TYPE = Object.freeze({
  FMECA: 'Fmeca',
  NPA: 'Npa',
});
